import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { parseMessage } from "./parser";
import { TableBlock } from "./TableBlock";
import { DashboardBlock } from "./DashboardBlock";
import { KanbanBlock } from "./KanbanBlock";
import { ActionsBlock } from "./ActionsBlock";
import { FullscreenBlock } from "./FullscreenBlock";
import { ApproveBlock } from "./ApproveBlock";
import { CompanyCardBlock } from "./CompanyCardBlock";
import { DevCardBlock } from "./DevCardBlock";
import { MiniWeekBlock } from "./MiniWeekBlock";
import { MiniListBlock } from "./MiniListBlock";

export function MessageContent({
  content,
  onPrompt,
}: {
  content: string;
  /** Optional: invoked when the user clicks a `kind:"prompt"` action button. Lets the chat send the pre-filled text as a follow-up message. */
  onPrompt?: (text: string) => void;
}) {
  const parts = parseMessage(content);
  return (
    <>
      {parts.map((p, i) => {
        if (p.type === "text") {
          return (
            <div
              key={i}
              className="prose prose-sm max-w-none dark:prose-invert [&_p]:my-1 [&_ul]:my-1 [&_ol]:my-1"
            >
              <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {p.content}
              </ReactMarkdown>
            </div>
          );
        }
        switch (p.block.kind) {
          case "table":
            return <TableBlock key={i} payload={p.block.payload} />;
          case "dashboard":
            return <DashboardBlock key={i} payload={p.block.payload} />;
          case "kanban":
            return <KanbanBlock key={i} payload={p.block.payload} />;
          case "actions":
            return (
              <ActionsBlock
                key={i}
                payload={p.block.payload}
                onPrompt={onPrompt}
              />
            );
          case "fullscreen":
            return <FullscreenBlock key={i} payload={p.block.payload} />;
          case "approve":
            return <ApproveBlock key={i} payload={p.block.payload} />;
          case "company-card":
            return <CompanyCardBlock key={i} payload={p.block.payload} />;
          case "dev-card":
            return <DevCardBlock key={i} payload={p.block.payload} />;
          case "mini-week":
            return <MiniWeekBlock key={i} payload={p.block.payload} />;
          case "mini-list":
            return <MiniListBlock key={i} payload={p.block.payload} />;
          default:
            return null;
        }
      })}
    </>
  );
}
